import React, { useState, useEffect } from "react";
import { FaArrowRight, FaMapMarkerAlt, FaCompass } from "react-icons/fa";
import "../Vender/css/AestheticHero.css";

const AestheticHero = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isAnimating, setIsAnimating] = useState(false);

  const slides = [
    {
      id: 1,
      image: "/assets/images/banner-img2-beach.jpg",
      category: "Exclusive",
      title: "Maldives",
      subtitle: "The Archipelago of Dreams",
      description:
        "Surrender to the rhythm of the tides in overwater sanctuaries designed for ultimate seclusion.",
      coords: "3.2028° N, 73.2207° E",
    },
    {
      id: 2,
      image: "/assets/images/dubai-bg.jpeg",
      category: "Luxury",
      title: "Dubai",
      subtitle: "City of Gold and Dreams",
      description:
        "Experience the pinnacle of luxury in a city where modern marvels touch the sky and desert meets the sea.",
      coords: "25.2048° N, 55.2708° E",
    },
    {
      id: 3,
      image: "/assets/images/south-india.jpg",
      category: "Heritage",
      title: "Kerala",
      subtitle: "God's Own Country",
      description:
        "Drift through emerald backwaters and discover ancient traditions hidden within the lush tropics.",
      coords: "10.8505° N, 76.2711° E",
    },
  ];

  const handleNext = () => {
    if (isAnimating) return;
    setIsAnimating(true);
    setCurrentSlide((prev) => (prev + 1) % slides.length);
    setTimeout(() => setIsAnimating(false), 1200);
  };

  const handlePrev = () => {
    if (isAnimating) return;
    setIsAnimating(true);
    setCurrentSlide((prev) => (prev - 1 + slides.length) % slides.length);
    setTimeout(() => setIsAnimating(false), 1200);
  };

  useEffect(() => {
    const timer = setInterval(handleNext, 6000);
    return () => clearInterval(timer);
  }, [currentSlide, isAnimating]);

  return (
    <section className="aesthetic-hero">
      {/* 1. ARTISTIC BRAND WATERMARK LAYER */}
      <div className="brand-watermark">
        <span>AACORE</span>
      </div>

      {/* Background Layer */}
      <div className="hero-bg-wrapper">
        {slides.map((slide, index) => (
          <div
            key={slide.id}
            className={`hero-bg-image ${index === currentSlide ? "active" : ""}`}
            style={{ backgroundImage: `url(${slide.image})` }}
          >
            <div className="bg-overlay" />
          </div>
        ))}
      </div>

      {/* Main Interface */}
      <div className="hero-interface">
        {/* 2. UPDATED HEADER WITH LUXURY LOGO */}
        <div className="hero-header"></div>

        {/* Content Container */}
        <div className="hero-content-grid">
          <div className="text-content-wrapper">
            {slides.map((slide, index) => (
              <div
                key={slide.id}
                className={`slide-text ${index === currentSlide ? "active" : ""}`}
              >
                <div className="category-wrapper">
                  <span className="slide-category">{slide.category}</span>
                  <span className="category-line"></span>
                </div>

                <div className="title-mask">
                  <h1 className="slide-title">{slide.title}</h1>
                </div>
                <div className="subtitle-mask">
                  <h2 className="slide-subtitle">{slide.subtitle}</h2>
                </div>
                <p className="slide-desc">{slide.description}</p>
              </div>
            ))}
          </div>
        </div>
        {/* Bottom Controls */}
        <div className="hero-footer">
          <div className="slide-counter">
            <span className="current">0{currentSlide + 1}</span>
            <div className="progress-bar">
              <div key={currentSlide} className="progress-fill"></div>
            </div>
            <span className="total">0{slides.length}</span>
          </div>

          <div className="nav-arrows">
            <button
              onClick={handlePrev}
              disabled={isAnimating}
              className="nav-btn"
            >
              Prev
            </button>
            <button
              onClick={handleNext}
              disabled={isAnimating}
              className="nav-btn"
            >
              Next
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AestheticHero;
